<div class="settings-section" *ngIf="form" [formGroup]="form">
  <h3 class="section-heading">Training Schedule</h3>
  <p class="section-desc">Update the session title and date/time information. Add multiple date ranges for multi-session classes.</p>

  <mat-form-field appearance="outline" class="form-field-full">
    <mat-label>Session Title</mat-label>
    <input matInput formControlName="title">
    <mat-error *ngIf="form.get('title')?.hasError('required')">Title is required</mat-error>
  </mat-form-field>

  <div class="date-ranges-section">
    <div formArrayName="dateRanges">
      <div *ngFor="let ctrl of ranges.controls; let i = index"
           [formGroupName]="i"
           class="date-range-row">

        <div class="range-row-header">
          <span class="range-label">Session Slot {{ i + 1 }}</span>
          <button mat-icon-button type="button" color="warn"
            (click)="removeRange(i)"
            [disabled]="ranges.length === 1"
            matTooltip="Remove this date range">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </div>

        <div class="compact-row">
          <!-- Single calendar that lets the user pick start + end dates in one interaction -->
          <mat-form-field appearance="outline" class="date-range-field">
            <mat-label>Date Range</mat-label>
            <mat-date-range-input [rangePicker]="rangePicker" (click)="rangePicker.open()">
              <input matStartDate formControlName="startDate" placeholder="Start date" readonly>
              <input matEndDate formControlName="endDate" placeholder="End date" readonly>
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="rangePicker"></mat-datepicker-toggle>
            <mat-date-range-picker #rangePicker></mat-date-range-picker>
            <mat-error *ngIf="ctrl.get('startDate')?.hasError('required') || ctrl.get('endDate')?.hasError('required')">
              Both start and end dates are required
            </mat-error>
            <mat-error *ngIf="ctrl.get('endDate')?.hasError('matEndDateInvalid')">
              End date must be on or after the start date
            </mat-error>
          </mat-form-field>

          <app-time-picker
            class="time-field"
            formControlName="startTime"
            label="Start Time">
          </app-time-picker>

          <app-time-picker
            class="time-field"
            formControlName="endTime"
            label="End Time">
          </app-time-picker>
        </div>

        <!-- Group-level validation errors (cross-field, shown below the row) -->
        <div class="range-errors">
          <span class="range-error-msg" *ngIf="rangeHasError(i, 'endBeforeStart')">
            End date must be on or after the start date.
          </span>
          <span class="range-error-msg" *ngIf="rangeHasError(i, 'endTimeBeforeStart')">
            End time must be after start time when the session is on the same day.
          </span>
        </div>

        <mat-divider *ngIf="i < ranges.length - 1" class="range-divider"></mat-divider>
      </div>
    </div>

    <div class="add-range-row">
      <button mat-stroked-button type="button" (click)="addRange()">
        <mat-icon>add</mat-icon> Add Session Slot
      </button>
    </div>
  </div>

  <div class="section-actions">
    <button mat-flat-button color="primary"
      [disabled]="form.invalid || isSaving"
      (click)="save()">
      <mat-spinner *ngIf="isSaving" diameter="18" class="btn-spinner"></mat-spinner>
      <mat-icon *ngIf="!isSaving">save</mat-icon>
      {{ isSaving ? 'Saving…' : 'Save Schedule' }}
    </button>
  </div>
</div>
